import React from "react";
import { Link } from "react-router-dom";

const Solutions = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="section" style={{ background: 'var(--gradient-primary)', color: 'white', paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="container text-center">
          <h1 style={{ color: 'white', fontSize: '3rem', marginBottom: '1.5rem' }}>
            Our <span style={{ color: 'var(--primary-green)' }}>SaaS Solutions</span>
          </h1>
          <p style={{
            fontSize: '1.25rem',
            maxWidth: '800px',
            margin: '0 auto',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.7
          }}>
            Comprehensive software solutions designed to transform your business operations and drive sustainable growth.
          </p>
        </div>
      </section>

      {/* Main Solutions */}
      <section className="section">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Innovative Technology Solutions</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              From custom software development to AI-powered automation and advanced trading systems, we deliver cutting-edge solutions that drive growth and efficiency.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
            {solutions.map((solution, index) => (
              <div key={index} className="card" style={{
                background: index % 2 === 0 ? 'var(--white)' : 'var(--gray-50)',
                padding: '3rem',
                border: index % 2 === 0 ? '1px solid var(--gray-200)' : 'none'
              }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: window.innerWidth > 768 ? '1fr 2fr' : '1fr',
                  gap: '3rem',
                  alignItems: 'center'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '4rem',
                      marginBottom: '1.5rem',
                      background: 'var(--gradient-accent)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}>
                      {solution.icon}
                    </div>
                    <h3 style={{ fontSize: '1.75rem', marginBottom: '1rem', color: 'var(--primary-green)' }}>
                      {solution.name}
                    </h3>
                    <p style={{ color: 'var(--gray-600)', fontSize: '1.125rem', lineHeight: 1.6 }}>
                      {solution.description}
                    </p>
                  </div>

                  <div>
                    <h4 style={{ color: 'var(--gray-800)', marginBottom: '1.5rem', fontSize: '1.25rem' }}>
                      Key Features:
                    </h4>
                    <div className="grid grid-2" style={{ gap: '1rem' }}>
                      {solution.features.map((feature, i) => (
                        <div key={i} style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '0.75rem',
                          padding: '1rem',
                          background: 'var(--white)',
                          borderRadius: 'var(--radius-md)',
                          border: '1px solid var(--gray-200)'
                        }}>
                          <div style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            background: 'var(--gradient-accent)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            marginTop: '0.125rem'
                          }}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                              <polyline points="20,6 9,17 4,12"></polyline>
                            </svg>
                          </div>
                          <div>
                            <h5 style={{ fontWeight: 600, marginBottom: '0.25rem', color: 'var(--gray-800)' }}>
                              {feature.title}
                            </h5>
                            <p style={{ fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0 }}>
                              {feature.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div style={{ marginTop: '2rem' }}>
                      <h4 style={{ color: 'var(--gray-800)', marginBottom: '1rem', fontSize: '1.125rem' }}>
                        Benefits:
                      </h4>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                        {solution.benefits.map((benefit, i) => (
                          <span key={i} style={{
                            background: 'var(--gradient-accent)',
                            color: 'white',
                            padding: '0.5rem 1rem',
                            borderRadius: 'var(--radius-md)',
                            fontSize: '0.9rem',
                            fontWeight: 500
                          }}>
                            {benefit}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Custom Solutions */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'center', gap: '4rem' }}>
            <div>
              <h2 style={{ marginBottom: '2rem' }}>Custom SaaS Development</h2>
              <p style={{ fontSize: '1.125rem', lineHeight: 1.7, marginBottom: '2rem' }}>
                Need something unique? Our expert development team creates bespoke SaaS solutions tailored to your specific business requirements and industry needs.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginBottom: '2rem' }}>
                {customFeatures.map((feature, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                    <div style={{
                      fontSize: '1.5rem',
                      background: 'var(--gradient-primary)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      flexShrink: 0
                    }}>
                      {feature.icon}
                    </div>
                    <div>
                      <h4 style={{ marginBottom: '0.5rem', color: 'var(--gray-800)' }}>{feature.title}</h4>
                      <p style={{ color: 'var(--gray-600)' }}>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <Link to="/contact" className="btn btn-primary">
                Discuss Your Custom Solution
              </Link>
            </div>

            <div className="card" style={{ padding: '3rem', background: 'var(--white)', border: '1px solid var(--gray-200)' }}>
              <h3 style={{ color: 'var(--primary-green)', marginBottom: '2rem', textAlign: 'center' }}>
                Our Development Process
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                {developmentProcess.map((step, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: 'var(--gradient-accent)',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      flexShrink: 0
                    }}>
                      {index + 1}
                    </div>
                    <div>
                      <h5 style={{ marginBottom: '0.5rem', color: 'var(--gray-800)' }}>{step.title}</h5>
                      <p style={{ fontSize: '0.95rem', color: 'var(--gray-600)', margin: 0 }}>{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Integration & Support */}
      <section className="section">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Seamless Integration & Support</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              Our solutions work together and integrate with your existing systems
            </p>
          </div>

          <div className="grid grid-3">
            {integrationFeatures.map((feature, index) => (
              <div key={index} className="card text-center">
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '1.5rem',
                  background: 'var(--gradient-accent)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  {feature.icon}
                </div>
                <h3 style={{ marginBottom: '1rem', color: 'var(--primary-green)' }}>{feature.title}</h3>
                <p style={{ color: 'var(--gray-600)' }}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section" style={{ background: 'var(--gradient-hero)', color: 'white' }}>
        <div className="container text-center">
          <h2 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '1rem' }}>
            Ready to Get Started?
          </h2>
          <p style={{
            fontSize: '1.25rem',
            marginBottom: '2rem',
            color: 'rgba(255, 255, 255, 0.9)',
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Let's discuss which solution is right for your business and how we can help you achieve your goals.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn btn-accent">
              Request a Demo
            </Link>
            <Link to="/why-us" className="btn btn-outline" style={{ color: 'white', borderColor: 'white' }}>
              Why Choose Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

const solutions = [
  {
    name: "Custom Solutions",
    icon: "�",
    description: "Tailored software solutions designed specifically for your unique business requirements and processes, built from the ground up to match your exact needs.",
    features: [
      {
        title: "Bespoke Development",
        description: "Custom-built applications designed to your exact specifications"
      },
      {
        title: "Industry-Specific Features",
        description: "Specialized functionality tailored to your industry requirements"
      },
      {
        title: "Custom Architecture",
        description: "Scalable system architecture designed for your growth path"
      },
      {
        title: "API Development",
        description: "Custom APIs for seamless integration with existing systems"
      },
      {
        title: "User Experience Design",
        description: "Intuitive interfaces designed for your specific workflows"
      },
      {
        title: "Ongoing Support",
        description: "Dedicated maintenance and feature enhancement services"
      }
    ],
    benefits: ["Perfect Fit", "Competitive Advantage", "Scalable Growth", "Full Control"]
  },
  {
    name: "AI Workflows & Automation",
    icon: "🤖",
    description: "Intelligent automation powered by AI to streamline your business processes, reduce manual work, and increase operational efficiency through smart decision-making.",
    features: [
      {
        title: "Process Automation",
        description: "Automate repetitive tasks and complex business workflows"
      },
      {
        title: "AI-Powered Analytics",
        description: "Machine learning algorithms for predictive insights and patterns"
      },
      {
        title: "Smart Decision Making",
        description: "AI-driven recommendations and automated decision processes"
      },
      {
        title: "Workflow Optimization",
        description: "Continuous improvement of business processes through AI analysis"
      },
      {
        title: "Natural Language Processing",
        description: "Intelligent document processing and communication automation"
      },
      {
        title: "Predictive Maintenance",
        description: "AI-powered systems to predict and prevent issues before they occur"
      }
    ],
    benefits: ["Increased Efficiency", "Reduced Costs", "Better Accuracy", "24/7 Operations"]
  },
  {
    name: "Trading Applications to Automate Investments",
    icon: "�",
    description: "Advanced trading platforms and automated investment solutions designed for portfolio management, algorithmic trading, and strategic investment automation.",
    features: [
      {
        title: "Automated Trading Systems",
        description: "Algorithmic trading with customizable strategies and risk management"
      },
      {
        title: "Portfolio Management",
        description: "Comprehensive portfolio tracking, rebalancing, and optimization tools"
      },
      {
        title: "Risk Analysis & Management",
        description: "Advanced risk assessment and automated risk mitigation strategies"
      },
      {
        title: "Real-time Market Data",
        description: "Live market feeds and real-time price monitoring systems"
      },
      {
        title: "Backtesting Engine",
        description: "Historical data testing to validate trading strategies and performance"
      },
      {
        title: "Compliance & Reporting",
        description: "Automated compliance monitoring and detailed investment reporting"
      }
    ],
    benefits: ["Automated Execution", "Risk Mitigation", "24/7 Trading", "Data-Driven Strategies"]
  }
];

const customFeatures = [
  {
    icon: "🔧",
    title: "Tailored Architecture",
    description: "Custom-built solutions designed specifically for your business processes and requirements."
  },
  {
    icon: "🔗",
    title: "Seamless Integration",
    description: "Connect with your existing systems, databases, and third-party applications."
  },
  {
    icon: "📈",
    title: "Scalable Design",
    description: "Built to grow with your business, handling increased load and new features."
  },
  {
    icon: "🛡️",
    title: "Enterprise Security",
    description: "Advanced security features tailored to your industry and compliance requirements."
  }
];

const developmentProcess = [
  {
    title: "Discovery & Planning",
    description: "We analyze your requirements and create a detailed project roadmap."
  },
  {
    title: "Design & Prototyping",
    description: "Create user experience designs and interactive prototypes for validation."
  },
  {
    title: "Development & Testing",
    description: "Build your solution using agile methodology with continuous testing."
  },
  {
    title: "Deployment & Training",
    description: "Deploy to production and provide comprehensive user training."
  },
  {
    title: "Ongoing Support",
    description: "Continuous monitoring, updates, and feature enhancements."
  }
];

const integrationFeatures = [
  {
    icon: "🔄",
    title: "API Integration",
    description: "Connect with popular business tools and services through robust APIs and webhooks."
  },
  {
    icon: "📊",
    title: "Data Migration",
    description: "Seamless migration from your existing systems with zero data loss and minimal downtime."
  },
  {
    icon: "🎯",
    title: "24/7 Support",
    description: "Round-the-clock technical support and monitoring to ensure optimal performance."
  }
];

export default Solutions;